// extracted by mini-css-extract-plugin
module.exports = {"backToLogin":"GoToLogin_backToLogin__382jf","arrow":"GoToLogin_arrow__1ZHGn"};